var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5C10.3924 10.5 11.7277 9.94688 12.7123 8.96231C13.6969 7.97774 14.25 6.64239 14.25 5.25C14.25 3.85761 13.6969 2.52226 12.7123 1.53769C11.7277 0.553123 10.3924 0 9 0C7.60761 0 6.27226 0.553123 5.28769 1.53769C4.30312 2.52226 3.75 3.85761 3.75 5.25C3.75 6.64239 4.30312 7.97774 5.28769 8.96231C6.27226 9.94688 7.60761 10.5 9 10.5ZM2.625 12C1.92881 12 1.26113 12.2766 0.768845 12.7688C0.276562 13.2611 0 13.9288 0 14.625V15C0 16.7948 1.14225 18.3127 2.76375 19.3447C4.39425 20.3827 6.6015 21 9 21C11.3985 21 13.605 20.3827 15.2362 19.3447C16.8577 18.3127 18 16.7948 18 15V14.625C18 13.9288 17.7234 13.2611 17.2312 12.7688C16.7389 12.2766 16.0712 12 15.375 12H2.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.a569142aa717182046c8304026faf905.svg";
export { ForwardRef as ReactComponent };